import React from 'react';
import ReactDOM from 'react-dom';
import './popupautor.css'; // Asegúrate de importar los estilos
import back_i from '../../assets/imgs/libro_bitcoin/fondo-bitcoin-left-low.png';
import back_d from '../../assets/imgs/libro_bitcoin/fondo-bitcoin-right-low.png';

const popupAutor = ({ onClose, content }) => {
    return ReactDOM.createPortal(
        <div className="popup_overlay_autor" onClick={onClose}>
            <div className="popup_content" onClick={e => e.stopPropagation()}>
                <button className="close_btn" onClick={onClose}>×</button>
                {content}
                <img class="landing_bitcoin_registro_img_i" src={back_i}></img>
                <img class="landing_bitcoin_registro_img_d" src={back_d}></img>
            </div>
            
        </div>,
        document.body
    );
};

export default popupAutor;